<template>
  <div class="technology">
    <home-head
      :data="{
        Ename: 'NTELLIGENT TECHNOLOGY',
        Cname: '智能科技',
        Fname: 'I',
        url: '/technology',
      }"
    ></home-head>
    <div class="list">
      <ul class="flex-box">
        <li v-for="(item, index) of Data" :key="index">
          <router-link to="" class="flex-box">
            <div class="item-img"><img :src="item.img" /></div>
            <div class="item-content">
              <p>{{ item.name }}</p>
              <p>{{ item.content }}</p>
            </div>
          </router-link>
        </li>
      </ul>
    </div>
  </div>
</template>
<script>
import HomeHead from "@/components/HomeHead";
import { getHomeTochnology } from "@/api";
export default {
  components: {
    ["home-head"]: HomeHead,
  },
  data () {
    return {
      Data: [],
    };
  },
  methods: {
    async getHomeTochnology () {
      const result = await getHomeTochnology();
      this.Data = result.data.data;
    },
  },
  created () {
    this.getHomeTochnology();
  },
};
</script>
<style lang="scss" scoped>
.technology {
  font-size: 12px;
  background: #fff;
  .list {
    margin: 30px 0;
    ul {
      flex-wrap: wrap;
      padding: 0 15px;
      li {
        width: 310px;
        height: 200px;
        margin: 10px 0;
        box-shadow: #cecece 0px 0px 5px 1px;
        border: 1px solid #fff;
        .item-img {
          width: 74px;
          height: 74px;
          padding: 0 30px;
          border-right: 1px solid #d3d3d3;
          img {
            object-fit: contain;
          }
        }
        .item-content {
          width: 224px;
          margin: 0 20px;
          height: 100%;
          border: none;
          overflow: hidden;
          :nth-child(1) {
            text-align: center;
            font-size: 20px;
            margin: 10px 0;
          }
          :nth-child(2) {
            overflow: hidden;
            text-overflow: clip;
            display: -webkit-box;
            -webkit-box-orient: vertical;
            text-overflow: ellipsis;
            -webkit-line-clamp: 4;
            margin-top: 25px;
          }
        }
        &:hover {
          border-color: $color-blue;
          .item-content {
            :nth-child(1) {
              color: $color-blue;
            }
          }
        }
      }
    }
  }
}
</style>